// src/features/streams/components/StreamsLayout.tsx

import { useEffect, useRef } from 'react';
import { Outlet, useRouterState } from '@tanstack/react-router';
import { SelectionProvider } from '@/shared/contexts/SelectionContext';
import { useStreamGridState } from '../stores/streamGridState';
import { markStart } from '@/shared/utils/perf';

/**
 * Layout route for /streams.
 * SelectionProvider wraps both list and detail routes so selection persists.
 * Grid/search/sort/scroll state persistence is handled by Zustand store.
 */
export function StreamsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const markBackNavStart = useStreamGridState((s) => s.markBackNavStart);
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    // Sub-accounts is a sibling list view, not a detail page — exclude it so
    // the back-nav perf metric only measures detail → list transitions.
    const movedFromDetailToList =
      /^\/streams\/.+/.test(prevPath) &&
      !/^\/streams\/sub-accounts\/?$/.test(prevPath) &&
      (pathname === '/streams' || pathname === '/streams/');

    if (movedFromDetailToList) {
      markBackNavStart();
      markStart('streams.grid.backnav.firstRowsPaint');
    }

    prevPathRef.current = pathname;
  }, [pathname, markBackNavStart]);

  return (
    <SelectionProvider>
      <Outlet />
    </SelectionProvider>
  );
}
